// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import React from 'react';
import type { Icon } from 'iconsax-react';

const DocumentsIcon: Icon = ({ size = 24, color, variant: _variant, className, style, ...rest }) => {
  const id = React.useId();
  const clipId = `${id}-clip`;
  const maskId = `${id}-mask`;
  const paint = color || 'currentColor';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <g clipPath={`url(#${clipId})`}>
        <mask
          id={maskId}
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <path d="M23.5 0.5V23.5H0.5V0.5H23.5Z" fill="white" stroke="white" />
        </mask>
        <g mask={`url(#${maskId})`}>
          <path
            d="M7 1.75H8.5C9.32166 1.75 9.79999 1.8839 10.1416 2.08301C10.4909 2.28666 10.7521 2.58821 11.0996 3.0498L12.5996 5.0498C12.7404 5.23755 12.9054 5.47267 13.1562 5.60645C13.414 5.74377 13.7069 5.75 14 5.75H17C19.1878 5.75 20.4406 6.09104 21.1748 6.8252C21.909 7.55935 22.25 8.81222 22.25 11V17C22.25 19.1878 21.909 20.4406 21.1748 21.1748C20.4406 21.909 19.1878 22.25 17 22.25H7C4.81222 22.25 3.55935 21.909 2.8252 21.1748C2.09104 20.4406 1.75 19.1878 1.75 17V7C1.75 4.81222 2.09104 3.55935 2.8252 2.8252C3.55935 2.09104 4.81222 1.75 7 1.75ZM7 2.25C6.09863 2.25 5.34465 2.29228 4.72656 2.42285C4.1029 2.55461 3.58176 2.78347 3.18262 3.18262C2.78347 3.58176 2.55461 4.1029 2.42285 4.72656C2.29228 5.34465 2.25 6.09863 2.25 7V17C2.25 17.9014 2.29228 18.6554 2.42285 19.2734C2.55461 19.8971 2.78347 20.4182 3.18262 20.8174C3.58176 21.2165 4.1029 21.4454 4.72656 21.5771C5.34465 21.7077 6.09863 21.75 7 21.75H17C17.9014 21.75 18.6554 21.7077 19.2734 21.5771C19.8971 21.4454 20.4182 21.2165 20.8174 20.8174C21.2165 20.4182 21.4454 19.8971 21.5771 19.2734C21.7077 18.6554 21.75 17.9014 21.75 17V11C21.75 10.0986 21.7077 9.34465 21.5771 8.72656C21.4454 8.1029 21.2165 7.58176 20.8174 7.18262C20.4182 6.78347 19.8971 6.55461 19.2734 6.42285C18.6554 6.29228 17.9014 6.25 17 6.25H14C13.4178 6.25 13.0887 6.15012 12.8613 6.0166C12.6258 5.87816 12.4454 5.67386 12.1982 5.34766L10.7002 3.34961L10.6992 3.34863C10.4601 3.03136 10.2285 2.7075 9.87598 2.50684C9.51135 2.2993 9.07728 2.25 8.5 2.25H7Z"
            fill={paint}
            stroke={paint}
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { DocumentsIcon };
